import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-why-bsc-computer-science-is-the-best-oriented-course',
  templateUrl: './why-bsc-computer-science-is-the-best-oriented-course.component.html',
  styleUrls: ['./why-bsc-computer-science-is-the-best-oriented-course.component.scss']
})
export class WhyBscComputerScienceIsTheBestOrientedCourseComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
